module.exports = __webpack_public_path__ + "static/img/jifenduihuan.3bd6d1cb.jpg";